import { render } from "./OcrUploadList.vue?vue&type=template&id=a30c3c84&scoped=true"
import script from "./OcrUploadList.vue?vue&type=script&lang=js"
export * from "./OcrUploadList.vue?vue&type=script&lang=js"

import "./OcrUploadList.vue?vue&type=style&index=0&id=a30c3c84&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/00-client-web(prod)/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a30c3c84"]])

export default __exports__